import { Injectable, NgZone } from '@angular/core';
import { Subject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MessageService {
  private messageSource = new Subject<unknown>();
  private isListenerAdded = false;
  private messageListener: ((event: MessageEvent) => void) | null = null;

  constructor(private ngZone: NgZone) {}

  sendMessage(message: unknown): void {
    window.parent.postMessage(message, '*');
  }

  receiveMessage(): Observable<unknown> {
    if (!this.isListenerAdded) {
      this.isListenerAdded = true;

      // Store listener reference for cleanup
      this.messageListener = (event: MessageEvent) => {
        this.ngZone.run(() => {
          this.messageSource.next(event.data);
        });
      };

      window.addEventListener('message', this.messageListener);
    }

    return this.messageSource.asObservable();
  }

  // Public cleanup method to be called from components that need to clean up
  // Call this from component's ngOnDestroy when message listening should stop
  public cleanup(): void {
    if (this.messageListener !== null) {
      window.removeEventListener('message', this.messageListener);
      this.messageListener = null;
      this.isListenerAdded = false;
    }
  }
}
